import {GaiaRed} from '@gaia/colors';
import type mapboxgl from 'mapbox-gl';

export const iconImageExpression: mapboxgl.Expression = [
    'case',
    // first check for the existence of the `marker_*` properties. if yes, return `marker_type.marker_decoration.marker_color`. else, go to next case.
    [
        'all',
        ['!=', ['coalesce', ['get', 'marker_type'], ''], ''],
        ['!=', ['coalesce', ['get', 'marker_color'], ''], ''],
    ],
    [
        'concat',
        ['get', 'marker_type'],
        '.',
        ['coalesce', ['get', 'marker_decoration'], ''],
        '.',
        ['get', 'marker_color'],
    ],
    `pin..${GaiaRed}`,
];

// Preferred opacity for features that are "blurred" (i.e. another feature is "focused")
export const blurOpacity = 0.4;

export const selectionWhite = 'rgba(250,250,250,1)';
export const selectionGreen = 'rgba(10, 110, 10, 1)';

export function activeLineLayers(
    lineLayerId: string,
    shadowLayerId: string,
    source: string,
    lineColorExpression?: mapboxgl.Expression
): [mapboxgl.LineLayer, mapboxgl.LineLayer] {
    return [
        {
            type: 'line',
            id: shadowLayerId,
            maxzoom: 24,
            minzoom: 0,
            source,
            layout: {
                'line-cap': 'round',
                'line-join': 'round',
            },
            paint: {
                'line-width': 7,
                'line-opacity': 1,
                'line-color': lineColorExpression ?? selectionGreen,
                'line-blur': 2,
                'line-dasharray': [1, 0],
            },
        },
        {
            type: 'line',
            id: lineLayerId,
            maxzoom: 24,
            minzoom: 0,
            source,
            layout: {
                'line-join': 'round',
                'line-cap': 'round',
            },
            paint: {
                'line-width': 2,
                'line-opacity': 1,
                'line-color': selectionWhite,
                'line-dasharray': [1, 0],
            },
        },
    ];
}

export const defaultPinLayer: mapboxgl.SymbolLayer = {
    id: 'Override me with a fixed layer id. See fixedLayerIds.tsx',
    type: 'symbol',
    source: 'source',
    filter: [
        'all',
        ['!=', ['get', 'attr'], 'route'],
        ['!=', ['coalesce', ['get', 'archived'], ['get', 'deleted'], false], null],
        ['==', ['geometry-type'], 'Point'],
    ],
    paint: {
        'text-color': '#000',
        'text-halo-color': '#fff',
        'text-halo-width': 1,
        'icon-opacity': 1,
        'text-opacity': 1,
    },
    layout: {
        'icon-ignore-placement': true,
        'icon-allow-overlap': true,
        'icon-anchor': 'bottom',
        'icon-size': 1,
        'text-field': '{title}',
        'text-ignore-placement': false,
        'text-allow-overlap': false,
        'text-size': 10,
        'text-anchor': 'top',
        'text-optional': true,
        'icon-image': iconImageExpression,
        'text-font': ['Regular'],
    },
};
